module.exports = __webpack_public_path__ + "files/2ec8cfa8ab8a120c16492032544cf734.png";